import { render } from "./ErrorNotFound.vue?vue&type=template&id=8ec00972&scoped=true"
import script from "./ErrorNotFound.vue?vue&type=script&lang=js"
export * from "./ErrorNotFound.vue?vue&type=script&lang=js"

import "./ErrorNotFound.vue?vue&type=style&index=0&id=8ec00972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec00972"]])

export default __exports__